export enum CasinoFeatureFlags {
  CasinoFavorites = 'CasinoFavorites',
  CasinoFreeSpinsToken = 'CasinoFreeSpinsToken',
  CasinoGameFeatureBonusFeatures = 'CasinoGameFeatureBonusFeatures',
  CasinoGameFeatureMaxBet = 'CasinoGameFeatureMaxBet',
  CasinoGameFeatureMinBet = 'CasinoGameFeatureMinBet',
  CasinoGameFeatureMultiplier = 'CasinoGameFeatureMultiplier',
  CasinoGameFeaturePaylines = 'CasinoGameFeaturePaylines',
  CasinoGameFeatureRTP = 'CasinoGameFeatureRTP',
  CasinoGameFeatureWilds = 'CasinoGameFeatureWilds',
  CasinoGameInfo = 'CasinoGameInfo',
  CasinoGameInfoDescription = 'CasinoGameInfoDescription',
  CasinoGameInfoDesktop = 'CasinoGameInfoDesktop',
  CasinoGameInfoMobile = 'CasinoGameInfoMobile',
  CasinoInstantBonusesToken = 'CasinoInstantBonusesToken',
  CasinoLimits = 'eCasinoLimits',
  CasinoLiveRacesTCReqd = 'CasinoLiveRacesTCReqd',
  CasinoLiveRoulette = 'CasinoLiveRouletteResultsFeed',
  CasinoNonAuth = 'eCasinoNonAuth',
  CasinoRewardsStoreToken = 'CasinoRewardsStoreToken',
  CasinoScheduledDowntimeSplashPage = 'CasinoScheduledDowntimeSplashPage',
  CasinoServiceInterruptionSplashPage = 'CasinoServiceInterruptionSplashPage',
  CasinoSlotRacesTCReqd = 'CasinoSlotRacesTCReqd',
  CasinoSpinOfDay = 'CasinoSpinOfTheDay'
}
